import React from "react";
import styled from "styled-components";
import { imgText } from "../Views/Cameras/imgText";

const StyledSection = styled.section`
  position: relative;
  width: 320px;
  height: 180px;
  flex-shrink: 0;

  img.cameraFeed {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 5px;
    z-index: 1050;
  }
  img.heatOverlay {
    z-index: 1090;
    opacity: 0.4;
    /* opacity: 1; */
    border-radius: 5px;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 320px;
    height: 180px;
  }
`;

export interface CameraImageProps {
  showHeatmap: boolean;
  image: string;
  heatmap: string;
}

//Layout is determined here
const CameraImage: React.FC<CameraImageProps> = props => {
  return (
    <>
      <StyledSection>
        <img
          className="cameraFeed"
          // src={`data:image/jpeg;base64, ${props.image}`}
          src={`data:image/jpeg;base64, ${props.image}`}
        ></img>
        {props.showHeatmap && (
          <img
            className="heatOverlay"
            src={`data:image/jpeg;base64, ${props.heatmap}`}
          ></img>
        )}
      </StyledSection>
    </>
  );
};

export default CameraImage;
